// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"672":"5f7d5a75","842":"04c2473b"}[chunkId] + ".chunk.js";
};